var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page"},[_c('Menus',{attrs:{"title":"人民调解","home":true}}),_c('div',{staticClass:"container-flex"},[_c('div',{staticClass:"content"},[_c('Applyinfo',{attrs:{"url":_vm.url}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }